import { useNavigate } from "react-router-dom";

export default function HashTag({ hashtagData }) {
    const navigate = useNavigate();

    return (
        <div className="w-full  px-2 overflow-y-scroll">
            {hashtagData?.map((data) => (
                <div
                    key={data.hashtag}
                    className="flex items-center gap-2 mb-2"
                    onClick={() => navigate(`/hashtag/${data.hashtag}`, { state: { from: "search" } })}
                >
                    <img
                        alt={data.hashtag}
                        src="https://placehold.co/200x200"
                        className="h-10 w-10 rounded-md cursor-pointer bg-gray-300 dark:bg-gray-700"
                    />
                    <div className="flex flex-col">
                        <p className="text-[11px] text-black dark:text-white font-semibold">{data.hashtag}</p>
                        <p className="text-[10px] text-gray-500">{data.post_count} posts</p>
                    </div>
                </div>
            ))}
            {hashtagData?.length === 0 && (
                <div className="flex justify-center items-center h-[25vh]">
                    <p className="text-[12px] text-gray-500">
                        No hashtag found
                    </p>
                </div>
            )}
        </div>
    );
}
